import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Header } from '../components/ui/header';
import { Footer } from '../components/ui/footer';
import { DynamicForm } from '../components/DynamicForm';
import { API_BASE } from '../config/api';

export const FormPage = () => {
  const { slug } = useParams();
  const [formConfig, setFormConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  const backendUrl = API_BASE;

  useEffect(() => {
    fetchFormBasicInfo();
  }, [slug]);

  const fetchFormBasicInfo = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${backendUrl}/api/public/forms/${slug}`);
      
      if (response.ok) {
        const data = await response.json();
        setFormConfig(data.form);
      }
    } catch (err) {
      console.error('Failed to fetch form info', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col">
      <Header />
      
      <main className="flex-1 px-4 md:px-6 lg:px-8 py-12">
        <div className="max-w-5xl mx-auto">
          {loading ? (
            <div className="text-center py-12">
              <div className="inline-block w-8 h-8 border-3 border-[#1E40AF] border-t-transparent rounded-full animate-spin"></div>
            </div>
          ) : formConfig ? (
            <>
              {/* Form Header */}
              <div className="text-center mb-8">
                <h1 className="text-3xl md:text-4xl font-bold text-[#111827] mb-3">
                  {formConfig.title}
                </h1>
                {formConfig.description && (
                  <p className="text-base md:text-lg text-[#6B7280] max-w-2xl mx-auto">
                    {formConfig.description}
                  </p>
                )}
              </div>

              {/* Dynamic Form Component */}
              <DynamicForm formSlug={slug} />
            </>
          ) : null}
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default FormPage;
